// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pickUpAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/PickUpAddress";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

pickUpAddressStyles.container = {
    gap: 12,
};

pickUpAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        align-items: flex-end;
        gap: 8px 12px;
        ${xScreen("lte", "xs")} {
            flex-wrap: wrap;
        }
    `,
};

pickUpAddressStyles.headingText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

pickUpAddressStyles.findLocationLink = {
    typographyProps: {
        size: 12,
    },
};
